module.exports = __webpack_public_path__ + "img/r1.f5a8c983.png";